module.exports = "./img/desktop_logo.9d889eb.png";